import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment.development';
import { AuthComponent } from './features/auth/auth.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AuthComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  isLoading = true;

  constructor(private router: Router, private titleService: Title) {
    const title = 'WebEsoluzion';
    switch(environment.env) {
      case 'dev':
        this.titleService.setTitle(`[DEV] ${title}`)
        break;
      case 'int':
        this.titleService.setTitle(`[INT] ${title}`)
        break;
      default:
        this.titleService.setTitle(title);
        break;
    }
    this.router.events.subscribe(event => {
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isLoading = false;
      }
    });
  }
}
